import { render, staticRenderFns } from "./SelectProvinces.vue?vue&type=template&id=52eac558&"
import script from "./SelectProvinces.vue?vue&type=script&lang=js&"
export * from "./SelectProvinces.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports